<div class="container">
    <div class="buttons">
        <div class="button" *ngFor="let value of options; let i = index"
             (mousedown)="buttonState[i] = true"
             (mouseup)="buttonState[i] = false"
             [@pressState]="buttonState[i] ? 'down' : 'up'"
             (click)="onSelect(value)"
             [style.width]="buttonWidth"
             [ngClass]="{'selected': isSelect(value)}">
            {{ value }}
        </div>
    </div>
</div>
